<template>
  <div class="pagination">
    <a
      v-for="(item, index) in slides"
      :key="index"
      :href="('#' + item)"
      class="dot"
      :class="[('dot-' + index), { active: hash === item}]"
      @click="handleScroll"
    ></a>
  </div>
</template>
<style lang="scss">
.pagination {
  width: 2vw;
  position: fixed;
  z-index: 9999;
  bottom: 5.83vw;
  left: 3vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  .dot {
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.8);
    width: 0.5vw;
    height: 0.5vw;
    margin: 1.25vw 0;
    transition: 0.3s all;
    &.active {
      background-color: #8fffe9;
    }
  }
}

@media (max-width: 1024px) {
  .pagination {
    display: none;
    width: 4vw;
    bottom: 15vw;
    left: 2.5vw;
    .dot {
      width: 2vw;
      height: 2vw;
      margin: 4vw 0;
    }
  }
}
</style>

<script>
export default {
  props: {
    slides: Array,
    scrollController: Object
  },
  data () {
    return {
      hash: ''
    }
  },
  methods: {
    handleScroll (e) {
      e.preventDefault()
      this.hash = e.target.href.split('#')[1]
      this.scrollController.scrollTo(`#${this.hash}`)
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SlidesPagination.vue